import { AccountTransactionDetailModelDto } from '@treasury/api/channel';

export const defaultAccountTransactionDetailModelDto: AccountTransactionDetailModelDto = {
    id: 0,
    date: '',
    description: '',
    debit: 0,
    credit: 0,
    isDebit: false,
    checkImageNumber: '',
    postingSequence: 0,
    tranCodeType: '',
};
